import { render, staticRenderFns } from "./ResourceProcessingAlert.vue?vue&type=template&id=e0fb44b6"
import script from "./ResourceProcessingAlert.vue?vue&type=script&lang=js"
export * from "./ResourceProcessingAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports